namespace Solovis.Reports.Parameters {

  type IntervalSetParameterControlOptions = {
    mode?: 'intervalsOnly'
  }
  export class IntervalSetParameterControl extends Solovis.UI.BaseControl {
    static hasNewRender = true;

    private _intervalSetOptions;

    private _intervalSetLabel;
    private _intervalSetEditLink;
    private _settings: IntervalSetParameterControlOptions;

    constructor(options) {
      super(options);
      this._settings = options.settings ? options.settings as IntervalSetParameterControlOptions : {};
      this._intervalSetOptions = (typeof options.initialValue != "undefined") ? options.initialValue : null;
    }


    public doRender() {
      if (this.options.renderMode === 'modern') {
        this.doRenderNew();
      } else {
        this.doRenderClassic();
      }
    }

    public doRenderNew() {
      const self = this;
      const target = self.container[0];
      const intervalsOnly = this._settings.mode === 'intervalsOnly'

      if (!target) {
        return;
      }

      // NOTE: If we're not interested in "intervals only" then we follow the pattern for button => modal
      if (!intervalsOnly) {
        Solovis.UX.Utils.placeComponent(
          "ConfigureControl",
          target,
          {
            onClick: this._showIntervalSetEditor.bind(this)
          }
        );
        return;
      }

      const options = [
        { label: "Month to Date", value: 'mtd' },
        { label: "Quarter to Date", value: 'qtd' },
        { label: "Year to Date", value: 'ytd' },
        { label: "Since Inception", value: 'sinceInception' },
        { label: "Trailing 1 Year", value: 'yearsBack1' },
        { label: "Trailing 3 Years", value: 'yearsBack3' },
        { label: "Trailing 5 Years", value: 'yearsBack5' },
      ];
      const defaultValues = [];
      if (this._intervalSetOptions.mtd) {
        defaultValues.push('mtd');
      }
      if (this._intervalSetOptions.qtd) {
        defaultValues.push('qtd');
      }
      if (this._intervalSetOptions.ytd) {
        defaultValues.push('ytd');
      }
      if (this._intervalSetOptions.sinceInception) {
        defaultValues.push('sinceInception');
      }

      if (this._intervalSetOptions.sinceMonthsBack && this._intervalSetOptions.sinceMonthsBack.length > 0) {
        this._intervalSetOptions.sinceMonthsBack.forEach(monthsBack => {
          defaultValues.push(`monthsBack${monthsBack}`);
        });
      }

      this._intervalSetOptions.sinceYearsBack.forEach(yearsBack => {
        defaultValues.push(`yearsBack${yearsBack}`);
      });
      const defaultValue = options.filter(option => defaultValues.indexOf(option.value) > -1);

      Solovis.UX.Utils.placeComponent(
        'MultiSelect',
        target,
        {
          defaultValue,
          options,
          placeholder: "Select",
          onChange: (selections: any) => {
            const newValues = { sinceYearsBack: [] };
            selections.forEach(selection => {
              if (selection.value.indexOf('yearsBack') === 0) {
                newValues.sinceYearsBack.push(parseInt(selection.value.replace('yearsBack', '')));
              } else {
                newValues[selection.value] = true;
              }
            })
            this.setParameterValue(newValues);
          }
        }
      )
    }

    public doRenderClassic() {
      let self = this;

      this._intervalSetLabel = $("<a>").text("Interval Set").appendTo(this.container);
      this._intervalSetLabel.click(function () {
        self._showIntervalSetEditor();
      });

      this._intervalSetEditLink = $("<a>").appendTo(this.container)
        .css("padding-left", "5px")
        .html("<span class='fa fa-pencil'></span>");
      this._intervalSetEditLink.click(function () {
        self._showIntervalSetEditor();
      });
    }

    private _showIntervalSetEditor() {
      let editorDialog = new IntervalSetEditorDialog({
        intervalSetOptions: this._intervalSetOptions,
        saveCallback: (newIntervalSetOptions) => {
          this.setParameterValue(newIntervalSetOptions);
        }
      });

      editorDialog.show();
    }


    public _setCurrentIntervalSetOptions(newInteralSetOptions) {
      this._intervalSetOptions = newInteralSetOptions;
    }

    public setParameterValue(newValue, more?) {
      Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
        this, IntervalSetParameterControl, this._setCurrentIntervalSetOptions, newValue, more);
    }

    public getParameterValue() {
      return Solovis.deepCopy(this._intervalSetOptions);
    }

    public notifyParameterValueChanged() {
      $(this).trigger("parameterValueChanged");
    }
  }


  export class IntervalSetEditorDialog {

    private _intervalSetOptions: InvData.Util.IntervalSetOptions;
    private _saveCallback;

    private _formBuilder: Solovis.UI.InputControls.FormBuilder;
    private _dialog: Solovis.UI.Dialog;

    private _hasCustomFiscalYearStartMonth: boolean;

    public constructor(options) {
      this._intervalSetOptions = options.intervalSetOptions ? options.intervalSetOptions : {};
      this._saveCallback = options.saveCallback;

      let fiscalYearStartMonth = 1;
      if ((window as any).Solovis) {
        let solovisAny = (window as any).Solovis as any;
        if (solovisAny && solovisAny.Custom && solovisAny.Custom.ModelDefaults && solovisAny.Custom.ModelDefaults.fiscalYearStartMonth) {
          fiscalYearStartMonth = solovisAny.Custom.ModelDefaults.fiscalYearStartMonth;
        }
      }

      this._hasCustomFiscalYearStartMonth = fiscalYearStartMonth != 1;
    }

    public static GetSinceDayIdsOptions(intervalSetOptions: InvData.Util.IntervalSetOptions): Solovis.UI.InputControls.FormEntryOptions {
      return {
        name: "sinceDayIds",
        label: "Since Dates",

        help: "Create intervals that range from each specified date until the as-of-date.",

        initialValue: intervalSetOptions.sinceDayIds,

        createEditor: (createEditorOptions) => {
          let container = createEditorOptions.container;

          let initialDates = null;
          if (createEditorOptions.initialValue) {
            initialDates = _.map(createEditorOptions.initialValue, (dayId: number) => InvData.DayId.toDate(dayId));
          }

          let sinceDayIdListEditor = new Solovis.UI.VerticalOrderedListBuilder({
            controlHost: container,

            itemTypeLabel: "Date",
            showEditLinks: false,

            values: initialDates,

            editorCreator: function (editorDiv, initialValue) {

              let inputEditor = new Solovis.UI.InputControl({
                container: editorDiv,
                type: "date",
                value: initialValue
              });

              var editorInfo = {
                getValue: function () {
                  let date = inputEditor.value();
                  if (date) {
                    return InvData.DayId.forDate(date);
                  }
                  else {
                    return null;
                  }
                }
              };

              return editorInfo;
            },

            newValueGenerator: function () {
              return null;
            }
          });
          sinceDayIdListEditor.setAsCurrentControl();

          let editor: any = {
            getValue: () => {
              return sinceDayIdListEditor.getValues();
            }
          };

          return editor;
        }
      }
    }

    public static GetSinceMonthsBackOptions(intervalSetOptions: InvData.Util.IntervalSetOptions): Solovis.UI.InputControls.FormEntryOptions {
      return {
        name: "sinceMonthsBack",
        label: "Since Months Back",

        help: {
          html: "<p>Enter 'Since Months Back' list as a list of month counts separated by spaces or commas. "
            + " Create intervals going through as-of-day and back-dating the calendar month (if the as-of-day is mid-month, the partial month will count as a single month).</p>"
            + "<p>Example: 1, 3, 5, 10</p>",
        },

        initialValue: intervalSetOptions.sinceMonthsBack,

        createEditor: (createEditorOptions) => {
          let container = createEditorOptions.container;

          let textValue = null;
          if (!_.isEmpty(intervalSetOptions.sinceMonthsBack)) {
            textValue = intervalSetOptions.sinceMonthsBack.join(", ");
          }

          let textBox = $("<div>")
            .css("margin-bottom", "2px")
            .appendTo(container).dxTextBox({
              value: textValue
            }).dxTextBox("instance");

          let editor: any = {
            getValue: () => {
              let textValue = textBox.option("value");
              if (textValue) {
                let parts = [];
                let lastIndex = 0;
                let lastWasSplitter = true;
                for (let co = 0; co < textValue.length; co++) {
                  let ch = textValue[co];
                  if (ch == ' ' || ch == ',') {
                    if (lastIndex < co) {
                      let newPart = textValue.substring(lastIndex, co);
                      parts.push(newPart);
                    }
                    lastIndex = co + 1;
                    lastWasSplitter = true;
                  }
                  else {
                    lastWasSplitter = false;
                  }
                }

                if (!lastWasSplitter) {
                  let newPart = textValue.substring(lastIndex, textValue.length);
                  parts.push(newPart);
                }

                let values = [];
                for (let part of parts) {
                  let num = parseInt(part);
                  if (typeof num === "number" && !isNaN(num)) {
                    values.push(num);
                  }
                }

                if (!_.isEmpty(values)) {
                  return values;
                }
                else {
                  return null;
                }
              }
            }
          };

          return editor;
        }
      }
    }

    public static GetSinceYearsBackOptions(intervalSetOptions: InvData.Util.IntervalSetOptions): Solovis.UI.InputControls.FormEntryOptions {
      return {
        name: "sinceYearsBack",
        label: "Since Years Back",

        help: {
          html: "<p>Enter 'Since Years Back' list as a list of year counts separated by spaces or commas. "
            + " Create intervals going through as-of-day and back 12 months per year (if the as-of-day is mid-month, the 12th month will be a partial month for the final year).</p>"
            + "<p>Example: 1, 3, 5, 10</p>",
        },

        initialValue: intervalSetOptions.sinceYearsBack,

        createEditor: (createEditorOptions) => {
          let container = createEditorOptions.container;

          let textValue = null;
          if (!_.isEmpty(intervalSetOptions.sinceYearsBack)) {
            textValue = intervalSetOptions.sinceYearsBack.join(", ");
          }

          let textBox = $("<div>").appendTo(container).dxTextBox({
            value: textValue
          }).dxTextBox("instance");

          let editor: any = {
            getValue: () => {
              let textValue = textBox.option("value");
              if (textValue) {
                let parts = [];
                let lastIndex = 0;
                let lastWasSplitter = true;
                for (let co = 0; co < textValue.length; co++) {
                  let ch = textValue[co];
                  if (ch == ' ' || ch == ',') {
                    if (lastIndex < co) {
                      let newPart = textValue.substring(lastIndex, co);
                      parts.push(newPart);
                    }
                    lastIndex = co + 1;
                    lastWasSplitter = true;
                  }
                  else {
                    lastWasSplitter = false;
                  }
                }

                if (!lastWasSplitter) {
                  let newPart = textValue.substring(lastIndex, textValue.length);
                  parts.push(newPart);
                }

                let values = [];
                for (let part of parts) {
                  let num = parseInt(part);
                  if (typeof num === "number" && !isNaN(num)) {
                    values.push(num);
                  }
                }

                if (!_.isEmpty(values)) {
                  return values;
                }
                else {
                  return null;
                }
              }
            }
          };

          return editor;
        }
      }
    }

    public static GetRollingIntervalsOptions(rollingIntervals: InvData.Util.IntervalSetRollingInterval[]): Solovis.UI.InputControls.FormEntryOptions {
      return {
        name: "rollingIntervals",
        label: "Rolling Intervals",

        help: "In 'Rolling' mode, create a series of rolling intervals where the time period shifts by one month each interval. "
          + "If mode is set to 'Consecutive', the time period will shift so that one interval ends where the next begins.",

        initialValue: rollingIntervals,

        createEditor: (createEditorOptions) => {
          let container = createEditorOptions.container;

          let rollingIntervalListEditor = new Solovis.UI.VerticalOrderedListBuilder({
            controlHost: container,

            itemTypeLabel: "Rolling Interval",
            showEditLinks: false,

            values: createEditorOptions.initialValue,

            editorCreator: function (editorDiv, initialValue) {

              let rollingIntervalEditor = new RollingIntervalControl({
                controlHost: editorDiv,
                rollingInterval: initialValue
              });
              rollingIntervalEditor.setAsCurrentControl();

              var editorInfo = {
                getValue: function () {
                  return rollingIntervalEditor.getRollingInterval();
                }
              };

              return editorInfo;
            },

            newValueGenerator: function () {
              return {};
            }
          });
          rollingIntervalListEditor.setAsCurrentControl();

          let editor: any = {
            getValue: () => {
              return rollingIntervalListEditor.getValues();
            }
          };

          return editor;
        }
      }
    }

    public static GetDailyDaysBackOptions(daily: InvData.Util.IntervalSetDaily): Solovis.UI.InputControls.FormEntryOptions {
      return {
        name: "dailyDaysBack",
        label: "Daily (Days Back)",

        help: {
          html: "<p>Create for intervals for individual days, going back the specified number of days.</p>"
            + "<p>NOTE: Many statistics are only available at monthly level, but values such as market values"
            + "and transaction summaries will be usable with daily intervals.</p>"
        },

        initialValue: daily ? daily.daysBack : null,
        editor: {
          type: "numberAsString",
          numberAsStringOptions: {
            decimals: 0,
            width: 50
          }
        }
      };
    }

    public static GetSinceDateCumulativeIntervalsOptions(sinceDateCumulativeIntervals: InvData.Util.IntervalSetSinceDateCumulativeInterval[]): Solovis.UI.InputControls.FormEntryOptions {
      return {
        name: "sinceDateCumulativeIntervals",
        label: "Since Date Cumulative Intervals",

        help: "'Since Date Cumulative Intervals' is predominantly useful for looking at evolving cumulative returns since a date in the past.",

        initialValue: sinceDateCumulativeIntervals,

        createEditor: (createEditorOptions) => {
          let container = createEditorOptions.container;

          let intervalDataListEditor = new Solovis.UI.VerticalOrderedListBuilder({
            controlHost: container,

            itemTypeLabel: "Since Date Cumulative Interval",
            showEditLinks: false,

            values: createEditorOptions.initialValue,

            editorCreator: function (editorDiv, initialValue) {

              let intervalDataEditor = new SinceDateCumulativeIntervalControl({
                controlHost: editorDiv,
                intervalData: initialValue
              });
              intervalDataEditor.setAsCurrentControl();

              var editorInfo = {
                getValue: function () {
                  return intervalDataEditor.getSinceDateCumulativeInterval();
                }
              };

              return editorInfo;
            },

            newValueGenerator: function () {
              return {};
            }
          });
          intervalDataListEditor.setAsCurrentControl();

          let editor: any = {
            getValue: () => {
              return intervalDataListEditor.getValues();
            }
          };

          return editor;
        }
      };
    }

    public show() {
      let formBuilderDiv = $("<div>");
      let formBuilder = new Solovis.UI.InputControls.FormBuilder({
        container: formBuilderDiv,
        width: 800,
        labelColumnWidth: 245
      });
      this._formBuilder = formBuilder;

      // Current
      formBuilder.addEntry({
        name: "basic",
        label: "Basic",

        initialValue: {
          oneDay: this._intervalSetOptions.oneDay,
          mtd: this._intervalSetOptions.mtd,
          qtd: this._intervalSetOptions.qtd,
          ytd: this._intervalSetOptions.ytd,
          fiscalYtd: this._intervalSetOptions.fiscalYtd
        },

        createEditor: (createEditorOptions) => {
          let container = createEditorOptions.container;
          container.css("padding-top", "8px");

          let horzSpacing = "10px";
          let addHorzSpacing = () => {
            $("<div>").css("display", "inline-block").css("width", horzSpacing).appendTo(container);
          };

          const verticalSpacing = "10px";
          const addVerticalSpacing = () => {
            $("<div>").css("display", "block").css("height", verticalSpacing).appendTo(container);
          };

          let oneDayCheckBox = $("<div>").appendTo(container).dxCheckBox({
            text: "1-Day", value: !!this._intervalSetOptions.oneDay
          }).dxCheckBox("instance");

          addHorzSpacing();

          let mtdCheckBox = $("<div>").appendTo(container).dxCheckBox({
            text: "MTD", value: !!this._intervalSetOptions.mtd
          }).dxCheckBox("instance");

          addHorzSpacing();

          let qtdCheckBox = $("<div>").appendTo(container).dxCheckBox({
            text: "QTD", value: !!this._intervalSetOptions.qtd
          }).dxCheckBox("instance");

          addHorzSpacing();

          let ytdCheckBox = $("<div>").appendTo(container).dxCheckBox({
            text: "YTD", value: !!this._intervalSetOptions.ytd
          }).dxCheckBox("instance");

          addHorzSpacing();

          let fytdCheckBox;
          if (this._intervalSetOptions.fiscalYtd || this._hasCustomFiscalYearStartMonth) {
            fytdCheckBox = $("<div>").appendTo(container).dxCheckBox({
              text: "FYTD", value: !!this._intervalSetOptions.fiscalYtd
            }).dxCheckBox("instance");
          }

          addHorzSpacing();

          let sinceInceptionCheckBox = $("<div>").appendTo(container).dxCheckBox({
            text: "Since Inception", value: !!this._intervalSetOptions.sinceInception
          }).dxCheckBox("instance");

          addVerticalSpacing();

          let sinceFirstFullMonthCheckBox = $("<div>").appendTo(container).dxCheckBox({
            text: "Since First Full Month", value: !!this._intervalSetOptions.sinceFirstFullMonth
          }).dxCheckBox("instance");

          addHorzSpacing();

          let sinceFirstFullQuarterCheckBox = $("<div>").appendTo(container).dxCheckBox({
            text: "Since First Full Quarter", value: !!this._intervalSetOptions.sinceFirstFullQuarter
          }).dxCheckBox("instance");

          addVerticalSpacing();

          let editor = {
            getValue: () => {
              let result: any = {};
              if (oneDayCheckBox.option("value")) {
                result.oneDay = true;
              }
              if (mtdCheckBox.option("value")) {
                result.mtd = true;
              }
              if (qtdCheckBox.option("value")) {
                result.qtd = true;
              }
              if (ytdCheckBox.option("value")) {
                result.ytd = true;
              }
              if (this._hasCustomFiscalYearStartMonth) {
                if (fytdCheckBox.option("value")) {
                  result.fiscalYtd = true;
                }
              }
              if (sinceInceptionCheckBox.option("value")) {
                result.sinceInception = true;
              }
              if (sinceFirstFullMonthCheckBox.option("value")) {
                result.sinceFirstFullMonth = true;
              }
              if (sinceFirstFullQuarterCheckBox.option("value")) {
                result.sinceFirstFullQuarter = true;
              }

              return result;
            }
          };

          return editor;
        }
      });

      formBuilder.addEntry(IntervalSetEditorDialog.GetSinceDayIdsOptions(this._intervalSetOptions));
      formBuilder.addEntry(IntervalSetEditorDialog.GetSinceMonthsBackOptions(this._intervalSetOptions));
      formBuilder.addEntry(IntervalSetEditorDialog.GetSinceYearsBackOptions(this._intervalSetOptions));

      formBuilder.addEntry({
        name: "consecutiveGroup",
        label: "Consecutive",
        isGroupHeader: true
      });

      formBuilder.addEntry({
        name: "consecutiveCalendarMonthsBack",
        label: "Consecutive Calendar Months Back",

        help: "Create for intervals for the individual calendar months preceeding as-of-date, starting with the month before as-of-date.",

        initialValue: this._intervalSetOptions.consecutiveCalendarMonthsBack,

        editor: {
          type: "numberAsString",
          numberAsStringOptions: {
            decimals: 0,
            width: 50
          }
        }
      });

      formBuilder.addEntry({
        name: "consecutiveCalendarQuartersBack",
        label: "Consecutive Calendar Quarters Back",

        help: "Create for intervals for the individual calendar quarters preceeding as-of-date, starting with the quarter before as-of-date.",

        initialValue: this._intervalSetOptions.consecutiveCalendarQuartersBack,

        editor: {
          type: "numberAsString",
          numberAsStringOptions: {
            decimals: 0,
            width: 50
          }
        }
      });

      formBuilder.addEntry({
        name: "consecutiveCalendarYearsBack",
        label: "Consecutive Calendar Years Back",

        help: "Create for intervals for the individual calendar years preceeding as-of-date, starting with the year before as-of-date.",

        initialValue: this._intervalSetOptions.consecutiveCalendarYearsBack,

        editor: {
          type: "numberAsString",
          numberAsStringOptions: {
            decimals: 0,
            width: 50
          }
        }
      });

      if (Solovis.isNotNull(this._intervalSetOptions.consecutiveFiscalYearsBack) || this._hasCustomFiscalYearStartMonth) {
        formBuilder.addEntry({
          name: "consecutiveFiscalYearsBack",
          label: "Consecutive Fiscal Years Back",

          help: "Create for intervals for the individual fiscal years preceeding as-of-date, starting with the fiscal before as-of-date.",

          initialValue: this._intervalSetOptions.consecutiveFiscalYearsBack,

          editor: {
            type: "numberAsString",
            numberAsStringOptions: {
              decimals: 0,
              width: 50
            }
          }
        });
      }

      formBuilder.addEntry({
        name: "includeFullFinalIntervalForConsecutiveIntervals",
        label: "Include Full Final Interval For Consecutive Intervals",

        help: "For consecutive intervals, if the as-of-date matches the end of a full interval, then include that interval in the consecutive interval collection."
          + " By default, the consecutive intervals start going back from the end of the prior complete interval.",

        initialValue: !!this._intervalSetOptions.includeFullFinalIntervalForConsecutiveIntervals,

        editor: {
          type: "bool"
        }
      });


      formBuilder.addEntry({
        name: "advancedGroup",
        label: "Advanced",
        isGroupHeader: true
      });

      formBuilder.addEntry(IntervalSetEditorDialog.GetRollingIntervalsOptions(this._intervalSetOptions.rollingIntervals));

      formBuilder.addEntry(IntervalSetEditorDialog.GetDailyDaysBackOptions(this._intervalSetOptions.daily));

      formBuilder.addEntry(IntervalSetEditorDialog.GetSinceDateCumulativeIntervalsOptions(this._intervalSetOptions.sinceDateCumulativeIntervals));


      formBuilder.setupDone();

      formBuilder.showAsDialog({
        title: "Edit Interval Set",

        desiredWidth: 800,
        desiredHeight: 600,

        showSaveCancel: true,
        saveButtonText: "OK",

        saveCallback: () => {
          let newOptions = this._formBuilder.getValueByName("basic");

          let sinceDayIds = this._formBuilder.getValueByName("sinceDayIds");
          if (sinceDayIds) {
            newOptions.sinceDayIds = sinceDayIds;
          }

          let sinceMonthsBack = this._formBuilder.getValueByName("sinceMonthsBack");
          if (sinceMonthsBack) {
            newOptions.sinceMonthsBack = sinceMonthsBack;
          }

          let sinceYearsBack = this._formBuilder.getValueByName("sinceYearsBack");
          if (sinceYearsBack) {
            newOptions.sinceYearsBack = sinceYearsBack;
          }

          let consecutiveCalendarMonthsBack = this._formBuilder.getValueByName("consecutiveCalendarMonthsBack");
          if (consecutiveCalendarMonthsBack) {
            newOptions.consecutiveCalendarMonthsBack = consecutiveCalendarMonthsBack;
          }

          let consecutiveCalendarQuartersBack = this._formBuilder.getValueByName("consecutiveCalendarQuartersBack");
          if (consecutiveCalendarQuartersBack) {
            newOptions.consecutiveCalendarQuartersBack = consecutiveCalendarQuartersBack;
          }

          let consecutiveCalendarYearsBack = this._formBuilder.getValueByName("consecutiveCalendarYearsBack");
          if (consecutiveCalendarYearsBack) {
            newOptions.consecutiveCalendarYearsBack = consecutiveCalendarYearsBack;
          }

          if (this._hasCustomFiscalYearStartMonth) {
            let consecutiveFiscalYearsBack = this._formBuilder.getValueByName("consecutiveFiscalYearsBack");
            if (consecutiveFiscalYearsBack) {
              newOptions.consecutiveFiscalYearsBack = consecutiveFiscalYearsBack;
            }
          }

          if (this._formBuilder.getValueByName("includeFullFinalIntervalForConsecutiveIntervals")) {
            newOptions.includeFullFinalIntervalForConsecutiveIntervals = true;
          }

          let rollingIntervals = this._formBuilder.getValueByName("rollingIntervals");
          if (!_.isEmpty(rollingIntervals)) {
            newOptions.rollingIntervals = rollingIntervals;
          }

          let dailyDaysBack = this._formBuilder.getValueByName("dailyDaysBack");
          if (dailyDaysBack) {
            let dailyDaysBackNum = parseInt(dailyDaysBack);
            if (dailyDaysBackNum) {
              newOptions.daily = { daysBack: dailyDaysBack };
            }
          }

          let sinceDateCumulativeIntervals = this._formBuilder.getValueByName("sinceDateCumulativeIntervals");
          if (!_.isEmpty(sinceDateCumulativeIntervals)) {
            newOptions.sinceDateCumulativeIntervals = sinceDateCumulativeIntervals;
          }

          this._saveCallback(newOptions);

          return true;
        }
      });
    }
  }



  export class RollingIntervalControl extends Solovis.UI.BaseControl {

    private _rollingInterval: InvData.Util.IntervalSetRollingInterval;
    private _formBuilder: Solovis.UI.InputControls.FormBuilder;

    constructor(options) {
      super(options);

      this._rollingInterval = options.rollingInterval;
    }

    public doRender() {
      let rollingInterval = this._rollingInterval ? this._rollingInterval : {};

      let formBuilderDiv = $("<div>").appendTo(this.container);
      let formBuilder = new Solovis.UI.InputControls.FormBuilder({
        container: formBuilderDiv,
        labelColumnWidth: 95,
        width: 240
      });
      this._formBuilder = formBuilder;

      formBuilder.addEntry({
        name: "monthSpan",
        label: "Month Span",

        initialValue: rollingInterval.monthSpan ? rollingInterval.monthSpan : 36,

        editor: {
          type: "integer",
          integerOptions: {
            width: 50
          }
        }
      });

      formBuilder.addEntry({
        name: "intervalCount",
        label: "Interval Count",

        initialValue: rollingInterval.intervalCount ? rollingInterval.intervalCount : 12,

        editor: {
          type: "integer",
          integerOptions: {
            width: 50
          }
        }
      });

      formBuilder.addEntry({
        name: "rollingMode",
        label: "Mode",

        initialValue: rollingInterval.endToEnd ? "Consecutive" : "Rolling",

        editor: {
          type: "select",
          selectOptions: {
            data: [
              { text: "Rolling", value: "Rolling" },
              { text: "Consecutive", value: "Consecutive" },
            ]
          }
        }
      });

      formBuilder.addEntry({
        name: "includeFinalPartialMonth",
        label: "Include Final Partial Month",

        initialValue: !!rollingInterval.includeFinalPartialMonth,

        editor: {
          type: "bool"
        }
      });

      formBuilder.setupDone();
    }

    public getRollingInterval(): InvData.Util.IntervalSetRollingInterval {
      if (!this._formBuilder) {
        return this._rollingInterval;
      }
      else {
        let monthSpan = this._formBuilder.getValueByName("monthSpan");
        let intervalCount = this._formBuilder.getValueByName("intervalCount");
        let includeFinalPartialMonth = this._formBuilder.getValueByName("includeFinalPartialMonth");
        let rollingMode = this._formBuilder.getValueByName("rollingMode");

        let newRollingInterval: InvData.Util.IntervalSetRollingInterval = {
          monthSpan: monthSpan,
          intervalCount: intervalCount,
          includeFinalPartialMonth: includeFinalPartialMonth,
          endToEnd: rollingMode === "Consecutive"
        };
        return newRollingInterval;
      }
    }

    public setWidth(newWidth) {
      if (this._formBuilder) {
        this._formBuilder.setWidth(newWidth);
      }
    }

  }



  export class SinceDateCumulativeIntervalControl extends Solovis.UI.BaseControl {

    private _intervalData: InvData.Util.IntervalSetSinceDateCumulativeInterval;
    private _formBuilder: Solovis.UI.InputControls.FormBuilder;

    constructor(options) {
      super(options);

      this._intervalData = options.intervalData;
    }

    public doRender() {
      let intervalData: InvData.Util.IntervalSetSinceDateCumulativeInterval = this._intervalData ? this._intervalData : {};

      let formBuilderDiv = $("<div>").appendTo(this.container);
      let formBuilder = new Solovis.UI.InputControls.FormBuilder({
        container: formBuilderDiv,
        labelColumnWidth: 95,
        width: 240
      });
      this._formBuilder = formBuilder;

      formBuilder.addEntry({
        name: "sinceDayId",
        label: "Since Date",

        initialValue: intervalData.sinceDayId ? intervalData.sinceDayId : null,

        editor: {
          type: "dayId"
        }
      });

      formBuilder.addEntry({
        name: "startingAtDayId",
        label: "Starting At",

        initialValue: intervalData.startingAtDayId ? intervalData.startingAtDayId : null,

        editor: {
          type: "dayId"
        }
      });

      formBuilder.addEntry({
        name: "advanceBy",
        label: "Advance By",

        initialValue: intervalData.advanceBy ? intervalData.advanceBy : "Year",

        editor: {
          type: "select",
          selectOptions: {
            data: [
              { text: "Year", value: "Year" },
              { text: "Quarter", value: "Quarter" },
              { text: "Month", value: "Month" },
            ]
          }
        }
      });

      formBuilder.setupDone();
    }

    public getSinceDateCumulativeInterval(): InvData.Util.IntervalSetSinceDateCumulativeInterval {
      if (!this._formBuilder) {
        return this._intervalData;
      }
      else {
        let sinceDayId = this._formBuilder.getValueByName("sinceDayId");
        let startingAtDayId = this._formBuilder.getValueByName("startingAtDayId");
        let advanceBy = this._formBuilder.getValueByName("advanceBy");

        let intervalData: InvData.Util.IntervalSetSinceDateCumulativeInterval = {
          sinceDayId: sinceDayId,
          startingAtDayId: startingAtDayId,
          advanceBy: advanceBy
        };
        return intervalData;
      }
    }

    public setWidth(newWidth) {
      if (this._formBuilder) {
        this._formBuilder.setWidth(newWidth);
      }
    }

  }
}